import React from 'react';
import EnhancedModuleEditor from '../../EnhancedModuleEditor';
import axios from 'axios';
import { API } from '../../../lib/api';

const ModulesTab = ({
  activeTab,
  bulkActionType,
  bulkTargetCategory,
  categories,
  confirmDeleteModule,
  deletingModule,
  deselectAllModules,
  duplicateModuleAction,
  editingModule,
  expandedCategories,
  formatDate,
  getFilteredModules,
  getModuleCompletionRate,
  getTypeColor,
  getTypeIcon,
  handleBulkAction,
  handleDeleteModule,
  moduleSearchTerm,
  modules,
  openPreviewModal,
  selectedCategoryFilter,
  selectedModules,
  selectedTypeFilter,
  setAnalytics,
  setBulkActionType,
  setBulkTargetCategory,
  setCategories,
  setDeletingModule,
  setEditingModule,
  setExpandedCategories,
  setModuleSearchTerm,
  setModules,
  setSelectedCategoryFilter,
  setSelectedModules,
  setSelectedTypeFilter,
  setShowAddModule,
  showAddModule,
  showModuleAnalytics,
  showSuccessNotification,
  toggleModuleSelection,
  toggleModuleStatusAction
}) => {
  return (
    <>
{activeTab === 'modules' && (
              <div className="space-y-6">
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-2xl font-bold text-slate-800">Module verwalten</h2>
                    <p className="text-slate-600 mt-1">Verwalten Sie alle Module mit erweiterten Funktionen</p>
                  </div>
                  <button
                    onClick={() => setShowAddModule(!showAddModule)}
                    className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-xl font-medium transition-colors shadow-lg hover:shadow-xl"
                  >
                    {showAddModule ? 'Abbrechen' : 'Neues Modul erstellen'}
                  </button>
                </div>

                {/* Phase 1: Search and Filter Bar */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Search Input */}
                    <div className="relative">
                      <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                      <input
                        type="text"
                        placeholder="Module durchsuchen..."
                        value={moduleSearchTerm || ''}
                        onChange={(e) => setModuleSearchTerm(e.target.value)}
                        className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      />
                    </div>
                    
                    {/* Category Filter */}
                    <select
                      value={selectedCategoryFilter || ''}
                      onChange={(e) => setSelectedCategoryFilter(e.target.value)}
                      className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    >
                      <option value="">Alle Kategorien</option>
                      {categories.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.title}</option>
                      ))}
                    </select>
                    
                    {/* Content Type Filter */}
                    <select
                      value={selectedTypeFilter || ''}
                      onChange={(e) => setSelectedTypeFilter(e.target.value)}
                      className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    >
                      <option value="">Alle Typen</option>
                      <option value="text">Text</option>
                      <option value="video">Video</option>
                      <option value="pdf">PDF</option>
                      <option value="document">Dokument</option>
                      <option value="quiz">Quiz</option>
                    </select>
                  </div>
                  
                  {/* Results Summary */}
                  <div className="mt-3 text-sm text-gray-600">
                    {getFilteredModules().length} von {modules.length} Modulen angezeigt
                  </div>
                </div>

                {/* Phase 2: Bulk Actions Bar */}
                {selectedModules.size > 0 && (
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <span className="text-sm font-medium text-blue-900">
                          {selectedModules.size} Module ausgewählt
                        </span>
                        <button
                          onClick={deselectAllModules}
                          className="text-blue-600 hover:text-blue-800 text-sm underline"
                        >
                          Alle abwählen
                        </button>
                      </div>
                      <div className="flex items-center space-x-2">
                        <select
                          value={bulkActionType}
                          onChange={(e) => setBulkActionType(e.target.value)}
                          className="px-3 py-1 border border-blue-300 rounded-lg text-sm"
                        >
                          <option value="">Aktion wählen...</option>
                          <option value="changeCategory">Kategorie ändern</option>
                          <option value="activate">Aktivieren</option>
                          <option value="deactivate">Deaktivieren</option>
                          <option value="delete">Löschen</option>
                        </select>
                        
                        {bulkActionType === 'changeCategory' && (
                          <select
                            value={bulkTargetCategory}
                            onChange={(e) => setBulkTargetCategory(e.target.value)}
                            className="px-3 py-1 border border-blue-300 rounded-lg text-sm"
                          >
                            <option value="">Zielkategorie...</option>
                            {categories.map(cat => (
                              <option key={cat.id} value={cat.id}>{cat.title}</option>
                            ))}
                          </select>
                        )}
                        
                        <button
                          onClick={handleBulkAction}
                          disabled={!bulkActionType || (bulkActionType === 'changeCategory' && !bulkTargetCategory)}
                          className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-4 py-1 rounded-lg text-sm font-medium transition-colors"
                        >
                          Ausführen
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Enhanced Module Editor für Admin */}
                {showAddModule && (
                  <EnhancedModuleEditor
                    isOpen={showAddModule}
                    onClose={() => setShowAddModule(false)}
                    onSuccess={() => {
                      setShowAddModule(false);
                      // Only refresh modules and categories, not all admin data
                      Promise.all([
                        axios.get(`${API}/modules`),
                        axios.get(`${API}/categories`),
                        axios.get(`${API}/admin/analytics`) // Also refresh analytics
                      ]).then(([modulesRes, categoriesRes, analyticsRes]) => {
                        setModules(modulesRes.data);
                        setCategories(categoriesRes.data);
                        setAnalytics(analyticsRes.data);
                        showSuccessNotification('Modul erfolgreich erstellt!');
                      });
                    }}
                    endpoint="modules"
                    existingCategories={categories}
                  />
                )}

                {/* Category-based Accordion Layout */}
                <div className="space-y-4">
                  {categories.map(category => {
                    const categoryModules = getFilteredModules().filter(m => m.category_id === category.id);
                    const isExpanded = expandedCategories.has(category.id);
                    
                    if (categoryModules.length === 0 && (selectedCategoryFilter || moduleSearchTerm || selectedTypeFilter)) {
                      return null; // Skip empty categories when filters are active
                    }
                    
                    return (
                      <div key={category.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        {/* Category Header */}
                        <div 
                          className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                          onClick={() => {
                            const newExpanded = new Set(expandedCategories);
                            if (isExpanded) {
                              newExpanded.delete(category.id);
                            } else {
                              newExpanded.add(category.id);
                            }
                            setExpandedCategories(newExpanded);
                          }}
                        >
                          <div className="flex items-center space-x-4 flex-1">
                            {/* Category Icon */}
                            <div 
                              className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl shadow-sm"
                              style={{ backgroundColor: category.color + '20' }}
                            >
                              {category.icon || '📁'}
                            </div>
                            
                            {/* Category Info */}
                            <div className="flex-1">
                              <div className="flex items-center gap-2 flex-wrap">
                                <h3 className="text-lg font-bold text-gray-900">{category.title}</h3>
                                {category.target_roles?.includes('teamleiter') ? (
                                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 border border-purple-200">👥 Teamleiter</span>
                                ) : (
                                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 border border-blue-200">💼 Vertriebler</span>
                                )}
                              </div>
                              <p className="text-sm text-gray-500">{categoryModules.length} Module</p>
                            </div>
                            
                            {/* Category Stats */}
                            <div className="flex items-center space-x-4 mr-4">
                              <div className="text-center">
                                <div className="text-sm font-semibold text-gray-900">{categoryModules.filter(m => m.is_active).length}</div>
                                <div className="text-xs text-gray-500">Aktiv</div>
                              </div>
                              <div className="text-center">
                                <div className="text-sm font-semibold text-gray-900">{Math.round(categoryModules.reduce((acc, m) => acc + getModuleCompletionRate(m.id), 0) / categoryModules.length || 0)}%</div>
                                <div className="text-xs text-gray-500">Ø Fortschritt</div>
                              </div>
                            </div>
                            
                            {/* Expand/Collapse Icon */}
                            <svg 
                              className={`w-6 h-6 text-gray-400 transition-transform ${isExpanded ? 'transform rotate-180' : ''}`}
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                        
                        {/* Modules List - Expandable */}
                        {isExpanded && categoryModules.length > 0 && (
                          <div className="border-t border-gray-200">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="px-6 py-3 text-left">
                                    <input
                                      type="checkbox"
                                      checked={categoryModules.every(m => selectedModules.has(m.id))}
                                      onChange={(e) => {
                                        const newSelected = new Set(selectedModules);
                                        if (e.target.checked) {
                                          categoryModules.forEach(m => newSelected.add(m.id));
                                        } else {
                                          categoryModules.forEach(m => newSelected.delete(m.id));
                                        }
                                        setSelectedModules(newSelected);
                                      }}
                                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                    />
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Titel
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Typ
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Position
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Erstellt
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Status
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Analytics
                                  </th>
                                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Aktionen
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {categoryModules.map((module) => (
                                  <tr key={module.id} className={`hover:bg-gray-50 ${selectedModules.has(module.id) ? 'bg-blue-50' : ''}`}>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <input
                                        type="checkbox"
                                        checked={selectedModules.has(module.id)}
                                        onChange={() => toggleModuleSelection(module.id)}
                                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                      />
                                    </td>
                                    <td className="px-6 py-4">
                                      <div className="flex items-center">
                                        <div className="cursor-move text-gray-400 hover:text-gray-600 mr-3">
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
                                          </svg>
                                        </div>
                                        <div>
                                          <div className="text-sm font-medium text-gray-900">{module.title}</div>
                                          <div className="text-sm text-gray-500 max-w-xs truncate">{module.description}</div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getTypeColor(module.content_type)}`}>
                                        {getTypeIcon(module.content_type)} {module.content_type.toUpperCase()}
                                      </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                      {module.order}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                      {formatDate(module.created_at)}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${module.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                        {module.is_active ? '● Aktiv' : '● Inaktiv'}
                                      </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="flex items-center space-x-2">
                                        <div className="w-16 bg-gray-200 rounded-full h-2">
                                          <div 
                                            className="bg-purple-500 h-2 rounded-full transition-all duration-300"
                                            style={{ width: `${getModuleCompletionRate(module.id)}%` }}
                                          />
                                        </div>
                                        <span className="text-xs text-gray-600">{getModuleCompletionRate(module.id)}%</span>
                                        <button
                                          onClick={() => showModuleAnalytics(module)}
                                          className="text-purple-600 hover:text-purple-800 p-1 rounded"
                                          title="Detaillierte Analytics"
                                        >
                                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2-2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                          </svg>
                                        </button>
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                      <div className="flex items-center justify-end space-x-2">
                                        <button
                                          onClick={() => duplicateModuleAction(module)}
                                          className="text-purple-600 hover:text-purple-800 p-1 rounded hover:bg-purple-50"
                                          title="Modul duplizieren"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                          </svg>
                                        </button>
                                        <button
                                          onClick={() => openPreviewModal(module)}
                                          className="text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50"
                                          title="Modul-Vorschau anzeigen"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                          </svg>
                                        </button>
                                        <button
                                          onClick={() => toggleModuleStatusAction(module)}
                                          className={`p-1 rounded transition-colors ${
                                            module.is_active 
                                              ? 'text-orange-600 hover:text-orange-800 hover:bg-orange-50' 
                                              : 'text-green-600 hover:text-green-800 hover:bg-green-50'
                                          }`}
                                          title={module.is_active ? 'Modul deaktivieren' : 'Modul aktivieren'}
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            {module.is_active ? (
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636" />
                                            ) : (
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            )}
                                          </svg>
                                        </button>
                                        <button
                                          onClick={() => setEditingModule(module)}
                                          className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                                          title="Modul bearbeiten"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                          </svg>
                                        </button>
                                        <button
                                          onClick={() => confirmDeleteModule(module)}
                                          className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                                          title="Modul löschen"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
                                          </svg>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        
                        {/* Empty State for Category */}
                        {isExpanded && categoryModules.length === 0 && (
                          <div className="border-t border-gray-200 py-8 text-center text-gray-500">
                            <p>Keine Module in dieser Kategorie</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  
                  {/* Module ohne Kategorie */}
                  {(() => {
                    const uncategorizedModules = getFilteredModules().filter(m => !m.category_id);
                    if (uncategorizedModules.length === 0) return null;
                    
                    const isExpanded = expandedCategories.has('uncategorized');
                    
                    return (
                      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        <div 
                          className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                          onClick={() => {
                            const newExpanded = new Set(expandedCategories);
                            if (isExpanded) {
                              newExpanded.delete('uncategorized');
                            } else {
                              newExpanded.add('uncategorized');
                            }
                            setExpandedCategories(newExpanded);
                          }}
                        >
                          <div className="flex items-center space-x-4 flex-1">
                            <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl shadow-sm bg-gray-100">
                              📂
                            </div>
                            <div className="flex-1">
                              <h3 className="text-lg font-bold text-gray-900">Ohne Kategorie</h3>
                              <p className="text-sm text-gray-500">{uncategorizedModules.length} Module</p>
                            </div>
                            <svg 
                              className={`w-6 h-6 text-gray-400 transition-transform ${isExpanded ? 'transform rotate-180' : ''}`}
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                        
                        {isExpanded && (
                          <div className="border-t border-gray-200 p-4 bg-gray-50">
                            <p className="text-sm text-gray-600">Module ohne zugewiesene Kategorie werden hier angezeigt.</p>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  
                  {/* Global Empty State */}
                  {categories.length === 0 && getFilteredModules().length === 0 && (
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 py-16 text-center">
                      <div className="text-gray-400 text-6xl mb-4">📚</div>
                      <h3 className="text-xl font-medium text-gray-900 mb-2">Keine Module gefunden</h3>
                      <p className="text-gray-500 mb-6">
                        {moduleSearchTerm || selectedCategoryFilter || selectedTypeFilter 
                          ? 'Versuchen Sie andere Suchkriterien.'
                          : 'Erstellen Sie Ihr erstes Modul um loszulegen.'
                        }
                      </p>
                      {!moduleSearchTerm && !selectedCategoryFilter && !selectedTypeFilter && (
                        <button
                          onClick={() => setShowAddModule(true)}
                          className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-xl font-medium transition-colors inline-flex items-center space-x-2"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                          <span>Neues Modul erstellen</span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
                
                {/* Module Edit Modal */}
                {editingModule && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                      <div className="flex justify-between items-center p-6 border-b border-gray-200">
                        <h2 className="text-2xl font-bold text-slate-800">Modul bearbeiten</h2>
                        <button
                          onClick={() => setEditingModule(null)}
                          className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      
                      <div className="p-6">
                        <EnhancedModuleEditor
                          isOpen={true}
                          onClose={() => setEditingModule(null)}
                          onSuccess={() => {
                            setEditingModule(null);
                            // Only refresh modules, not all admin data
                            Promise.all([
                              axios.get(`${API}/modules`),
                              axios.get(`${API}/admin/analytics`) // Also refresh analytics
                            ]).then(([modulesRes, analyticsRes]) => {
                              setModules(modulesRes.data);
                              setAnalytics(analyticsRes.data);
                              showSuccessNotification('Modul erfolgreich aktualisiert!');
                            });
                          }}
                          endpoint="modules"
                          editingModule={editingModule}
                          existingCategories={categories}
                        />
                      </div>
                    </div>
                  </div>
                )}
                
                {/* Module Delete Confirmation Modal */}
                {deletingModule && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
                      <div className="p-6">
                        <div className="flex items-center mb-4">
                          <div className="bg-red-100 rounded-full p-3 mr-4">
                            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-lg font-bold text-gray-900">Modul löschen</h3>
                            <p className="text-gray-600">Diese Aktion kann nicht rückgängig gemacht werden.</p>
                          </div>
                        </div>
                        
                        <div className="bg-gray-50 rounded-lg p-4 mb-6">
                          <p className="font-semibold text-gray-900 mb-2">Zu löschendes Modul:</p>
                          <p className="text-lg font-bold text-red-600">{deletingModule.title}</p>
                          <p className="text-sm text-gray-600 mt-1">{deletingModule.description}</p>
                          <div className="flex items-center mt-2 text-sm text-gray-500">
                            <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full font-medium mr-2">
                              {deletingModule.content_type.toUpperCase()}
                            </span>
                            {deletingModule.duration_minutes && (
                              <span>Dauer: {deletingModule.duration_minutes} Min</span>
                            )}
                          </div>
                        </div>
                        
                        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
                          <div className="flex items-start">
                            <svg className="w-5 h-5 text-yellow-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                            </svg>
                            <div className="text-sm">
                              <p className="font-semibold text-yellow-800 mb-1">Warnung:</p>
                              <ul className="text-yellow-700 space-y-1">
                                <li>• Alle Benutzer-Fortschritte werden gelöscht</li>
                                <li>• Alle zugehörigen Badges werden entfernt</li>
                                <li>• Das Modul wird dauerhaft entfernt</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        
                        <div className="flex space-x-3">
                          <button
                            onClick={() => setDeletingModule(null)}
                            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-3 rounded-xl font-medium transition-colors"
                          >
                            Abbrechen
                          </button>
                          <button
                            onClick={() => handleDeleteModule(deletingModule)}
                            className="flex-1 bg-red-600 hover:bg-red-700 text-white px-4 py-3 rounded-xl font-medium transition-colors flex items-center justify-center space-x-2"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            <span>Endgültig löschen</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
    </>
  );
};

export default ModulesTab;
